import type { StylesConfig } from 'react-select';

/**
 * react-select renders through emotion rather than class names, so Tailwind's
 * `dark:` variants never reach it. Pass this to any select rendered inside a
 * dark surface.
 */
export const darkSelectStyles: StylesConfig = {
  control: (base, state) => ({
    ...base,
    backgroundColor: '#27272a',
    borderColor: state.isFocused ? '#caab6a' : '#3f3f46',
    boxShadow: 'none',
    ':hover': {
      borderColor: state.isFocused ? '#caab6a' : '#52525b',
    },
  }),
  singleValue: (base) => ({ ...base, color: '#f4f4f5' }),
  input: (base) => ({ ...base, color: '#f4f4f5' }),
  placeholder: (base) => ({ ...base, color: '#a1a1aa' }),
  indicatorSeparator: (base) => ({ ...base, backgroundColor: '#3f3f46' }),
  dropdownIndicator: (base) => ({
    ...base,
    color: '#a1a1aa',
    ':hover': { color: '#e4e4e7' },
  }),
  clearIndicator: (base) => ({
    ...base,
    color: '#a1a1aa',
    ':hover': { color: '#e4e4e7' },
  }),
  loadingIndicator: (base) => ({ ...base, color: '#a1a1aa' }),
  menu: (base) => ({
    ...base,
    backgroundColor: '#27272a',
    border: '1px solid #3f3f46',
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? '#caab6a'
      : state.isFocused
        ? '#3f3f46'
        : 'transparent',
    color: state.isSelected ? '#18181b' : '#f4f4f5',
    ':active': { backgroundColor: state.isSelected ? '#caab6a' : '#52525b' },
  }),
  noOptionsMessage: (base) => ({ ...base, color: '#a1a1aa' }),
  loadingMessage: (base) => ({ ...base, color: '#a1a1aa' }),
  multiValue: (base) => ({ ...base, backgroundColor: '#3f3f46' }),
  multiValueLabel: (base) => ({ ...base, color: '#f4f4f5' }),
  multiValueRemove: (base) => ({
    ...base,
    color: '#a1a1aa',
    ':hover': { backgroundColor: '#52525b', color: '#f4f4f5' },
  }),
};
